import { render, staticRenderFns } from "./DocumentInsertionLabel.vue?vue&type=template&id=6dfea77e&"
import script from "./DocumentInsertionLabel.vue?vue&type=script&lang=ts&"
export * from "./DocumentInsertionLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports